/** User-facing Open Knots name only. Change this to rename the product in the UI. */
export const OPEN_KNOTS_LABEL = 'OPEN';

/** Matches "Open Knots", "Open Knot", "open knots", "openknots". */
const OPEN_KNOTS_NAME_PATTERN = /open\s*knots?/gi;

/** Build UI copy and rewrite leftover/API "Open Knots" text. Example: openKnotsCopy('Loading {openKnots}...') */
export const openKnotsCopy = (template) => {
    if (template == null) return template;
    return String(template)
        .replaceAll('{openKnots}', OPEN_KNOTS_LABEL)
        .replace(OPEN_KNOTS_NAME_PATTERN, OPEN_KNOTS_LABEL);
};
